import { Typography, Box } from '@vp/swan';
import React from 'react';
import { useLocalization } from './src-hooks-useLocalizations.js';

const MinimumOrderableQuantity = ({ quantity }) => {
  const { t } = useLocalization();
  const getMoqText = () => {
    if (quantity > 1) {
      return t("price-platform.minimum-quantity-units", { 0: quantity });
    } else {
      return "";
    }
  };
  return /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(Box, null, getMoqText()));
};

export { MinimumOrderableQuantity };
//# sourceMappingURL=src-components-MinimumOrderableQuantity.js.map
